var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerDetail",staticStyle:{"min-height":"500px"}},[_c('nav-view',{attrs:{"titleName":'详情'}}),_c('div',{staticClass:"centerWidth marginAuto",staticStyle:{"margin-top":"30px","min-height":"300px"},domProps:{"innerHTML":_vm._s(_vm.bannerDe)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }